// extracted by mini-css-extract-plugin
export var container = "_ia-1";
export var cornerButtonContainer = "_ia-6";
export var disabled = "_ia-2";
export var dragActive = "_ia-3";
export var fileContainer = "_ia-5";
export var hiddenInput = "_ia-4";
export var widthContainer = "_ia-0";